<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-dev-process`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M37 2a7 7 0 11-6.71 9.001L15.5 11a5.5 5.5 0 100 11h17a9.5 9.5 0 010 19l-14.79.001a7 7 0 110-4.001H32.5a5.5 5.5 0 100-11h-17a9.5 9.5 0 010-19h14.79c.86-2.892 3.539-5 6.71-5zM11 36a3 3 0 100 6 3 3 0 000-6zM34 9a3 3 0 116 0 3 3 0 01-6 0z"/></svg>
</template>
<script>

export default {
  name: 'IconDevProcess',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
